module.exports = __webpack_public_path__ + "assets/videos/intro/intro-3d-new-desktop/0057.jpg?v=a7f99505";